// App.js
import React from 'react';
import AppRoutes from './AppRoutes';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAuth } from './AuthContext';
import { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
const AuthHandler = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get("code");

    if (code) {
      const fetchToken = async () => {
        try {
          const response = await fetch("https://weavevo.com/auth/realms/master/protocol/openid-connect/token", {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
            body: new URLSearchParams({
              client_id: "weavevo-frontend",
              client_secret: "CaoSHmZcQVz7AVCaY9JwwbNXSUE4ULv2",
	      grant_type: "authorization_code",
              redirect_uri: "https://weavevo.com/auth/callback",
	      code,
            }),
          });

          if (!response.ok) throw new Error("Erreur échange code/token");

          const data = await response.json();
          const token = data.access_token;
          const payload = JSON.parse(atob(token.split(".")[1]));

          login(token, {
            name: payload.name,
            email: payload.email,
          });

          navigate("/dashboard");
        } catch (error) {
          console.error("Erreur Google Login:", error);
          navigate("/login");
        }
      };

      fetchToken();
    }
  }, [location.search, login, navigate]);

  return null;
};

const App = () => {
  return (
    <div className="d-flex flex-column min-vh-100">
      <AuthHandler />
      <main className="flex-grow-1">
        <AppRoutes />
      </main>
    </div>
  );
};

export default App;
